import ImportServices from '@root/modules/Sellers/Import/services/import';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface DataType {
  key: React.Key;
  wearDate: string;
  wearLocation: string;
  requestQuantity: number;
  availableQuantity: number;
  unavailableQuantity: number;
  quantityReceive: number;
  inspectionResult: string;
}
interface DataTypeReturn {
  key: React.Key;
  wearDate: string;
  wearLocation: string;
  requestQuantity: number;
  availableQuantity: number;
  unavailableQuantity: number;
  quantityReceive: number;
  inspectionResult: string;
}

interface PropsBox {
  flag?: boolean;
  listReturn?: any;
  productId?: string;
}

const ImportBox: React.FC<PropsBox> = ({ flag, listReturn, productId }: PropsBox) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([] as any);
  const { productId: paramProductId }: any = useParams();

  const columnsReturn: ColumnsType<DataTypeReturn> = [
    {
      title: 'Delivered Date',
      dataIndex: 'deliveredDate',
      sorter: (a, b) => moment(a.wearDate).unix() - moment(b.wearDate).unix()
    },
    {
      title: 'Location',
      dataIndex: 'location'
    },
    {
      title: 'Estimated Quantity',
      dataIndex: 'est'
    },
    {
      title: 'Delivered Quantity',
      dataIndex: 'deliveredQuantity'
    },
    {
      title: 'Available Quantity',
      dataIndex: 'availableQuantity'
    },
    {
      title: 'Unavailable Quantity',
      dataIndex: 'unAvailableQuantity'
    },
    {
      title: 'Inspection Result',
      dataIndex: 'inspectionResult'
    }
  ];

  const getDetail = async () => {
    console.log('productId', productId);
    console.log('paramProductId', paramProductId);
    const idToUse = productId || paramProductId;
    const detailProduct = await ImportServices.getListImportDetail(idToUse);
    const listProduct = detailProduct.data?.quotation.products.map(
      (item: any) => {
        return {
          wearDate: item.historyProductInboundInventory?.deliveredDt
            ? formatDateTime(item.historyProductInboundInventory?.deliveredDt)
            : null,
          wearLocation: item.historyProductInboundInventory?.location
            ? item.historyProductInboundInventory?.location
            : null,
          requestQuantity: item.historyProductInboundInventory?.estimatedQuantity
            ? item.historyProductInboundInventory?.estimatedQuantity
            : item.historyProductInboundInventory?.estimatedQuantity === 0
            ? 0
            : null,
          quantityReceive: item.historyProductInboundInventory?.deliveredQuantity
            ? item.historyProductInboundInventory?.deliveredQuantity
            : item.historyProductInboundInventory?.deliveredQuantity === 0
            ? 0
            : null,
          availableQuantity: item.historyProductInboundInventory?.availableQuantity
            ? item.historyProductInboundInventory?.availableQuantity
            : item.historyProductInboundInventory?.availableQuantity === 0
            ? 0
            : null,
          unavailableQuantity: item.historyProductInboundInventory?.unAvailableQuantity
            ? item.historyProductInboundInventory?.unAvailableQuantity
            : item.historyProductInboundInventory?.unAvailableQuantity === 0
            ? 0
            : null,
          inspectionResult: item.historyProductInboundInventory?.inspectionResult
            ? item.historyProductInboundInventory?.inspectionResult
            : null,
          otherResultDetail: item.historyProductInboundInventory?.otherResultDetail
            ? item.historyProductInboundInventory?.otherResultDetail
            : null
        };
      }
    );
    setList(listProduct);
  };

  useEffect(() => {
    getDetail();
  }, []);
  const columns: ColumnsType<DataType> = [
    {
      title: '입고 날짜',
      dataIndex: 'wearDate',
      sorter: (a, b) => moment(a.wearDate).unix() - moment(b.wearDate).unix()
    },
    {
      title: '입고 위치',
      dataIndex: 'wearLocation'
    },
    {
      title: '입고 요청 수량',
      dataIndex: 'requestQuantity'
    },
    {
      title: '입고된 수량',
      dataIndex: 'quantityReceive'
    },
    {
      title: '가용 수량',
      dataIndex: 'availableQuantity'
    },
    {
      title: '불가용 수량',
      dataIndex: 'unavailableQuantity'
    },
    {
      title: '검수 결과',
      dataIndex: 'inspectionResult'
    },
    {
      title: '기타 사유',
      dataIndex: 'otherResultDetail'
    }
  ];

  return (
    <Table
      loading={loading}
      columns={flag ? columnsReturn : columns}
      dataSource={flag ? listReturn : list}
      pagination={false}
    />
  );
};

export default ImportBox;
